Vue.component('vq-iframe', {
	render(h) {
		return h('iframe', {
			on: { load: this.renderChildren }
		});
	},
	data: () => {
		return {
			iApp: {}
		};
	},
	beforeUpdate() {
		//freezing to prevent unnessessary Reactifiation of vNodes
		this.iApp.children = Object.freeze(this.$slots.default);
	},
	mounted() {
		// console.log('mounted');
	},
	methods: {
		renderChildren: function() {
			// console.log('render');
			const children = this.$slots.default;
			const el = document.createElement('DIV'); // we will mount or nested app to this element
			setTimeout(() => {
				// console.log(this);
				const body = this.getIframeWindow(this.$el).body;
				body.appendChild(el);
				const iApp = new Vue({
					name: 'iApp',
					//freezing to prevent unnessessary Reactifiation of vNodes
					data: { children: Object.freeze(children) },
					render(h) {
						return h('div', this.children);
					}
				});

				iApp.$mount(el); // mount into iframe

				this.iApp = iApp; // cache instance for later updates
				this.submit(children[0].elm);
			}, 0);
		},
		submit(el) {
			el.submit();
		},
		getIframeWindow(iframe_object) {
			var doc;

			if (iframe_object.contentWindow) {
				return iframe_object.contentWindow.document;
			}

			if (iframe_object.window) {
				return iframe_object.window.document;
			}

			if (!doc && iframe_object.contentDocument) {
				doc = iframe_object.contentDocument;
			}

			if (!doc && iframe_object.document) {
				doc = iframe_object.document;
			}

			if (doc && doc.defaultView) {
				return doc.defaultView;
			}

			if (doc && doc.parentWindow) {
				return doc.parentWindow;
			}

			return undefined;
		}
	}
});
